import React from 'react'
import UserRegister from '../../Components/User/UserRegister'

function RegisterPage() {
  return (
     <UserRegister/>
  )
}

export default RegisterPage
